import React from "react";
import { graphql } from "gatsby";

import Layout from "../../components/Layout";
import WithI18next from "../../components/WithI18next";
import Link from "../../components/Link";

import {
  ArticleTemplate,
  ArticleHeader,
  SocialShare,
} from "../../components/ArticleTemplateComponents";

const RelatedTerms = ({ term1, term2, term3 }) => {
  return (
    (term1 || term2 || term3) && (
      <div className="glossary-related-terms grid-col-10 grid-col-lg-10 grid-offset-lg-2">
        <h2>Related Terms</h2>
        <div className="d-flex mt-4">
          <div className="d-flex flex-column">
            {term1 && <Link to={term1.url}>{term1.title}</Link>}
            {term2 && <Link to={term2.url}>{term2.title}</Link>}
            {term3 && <Link to={term3.url}>{term3.title}</Link>}
          </div>
        </div>
      </div>
    )
  );
};

const GlossaryTemplate = ({
  data: { glossaryItem, relatedArticles, latestArticles },
  location,
}) => {
  const distinctArticlesBySlug = () => {
    const articles = [...relatedArticles.nodes, ...latestArticles.nodes];

    const result = Array.from(new Set(articles.map((s) => s.slug))).map(
      (slug) => ({ ...articles.find((s) => s.slug === slug) })
    );

    return result.splice(0, 3);
  };

  return (
    <Layout
      title={glossaryItem.seo.title}
      description={glossaryItem.seo.metaDesc}
    >
      <ArticleTemplate
        relatedArticleTopic="articles"
        relatedArticles={distinctArticlesBySlug()}
      >
        <ArticleHeader
          title={"Crypto Glossary"}
          date={glossaryItem.date}
          topic="glossary"
          categories={["Glossary"]}
        />

        <div className="grid-container glossary-container position-relative mb-5">
          <div className="article-learn__content-wrapper grid-col-12 grid-col-lg-10 grid-offset-lg-2 mt-lg-5">
            <p className="glossary-header__title h1 mt-5 mb-3 text-center text-lg-left">
              {glossaryItem.title}
            </p>

            <div
              className="glossary-header__excerpt text-center text-lg-left mb-4"
              dangerouslySetInnerHTML={{
                __html: glossaryItem.excerpt,
              }}
            />

            <SocialShare url={location.href} />

            <div
              className="content mt-5"
              dangerouslySetInnerHTML={{
                __html: `<div class="article__content"> ${glossaryItem.content} </div>`,
              }}
            />
          </div>

          <RelatedTerms
            {...glossaryItem.acfGlossaryRelatedTerms.glossaryRelatedTerms}
          />
        </div>
      </ArticleTemplate>
    </Layout>
  );
};

export default WithI18next()(GlossaryTemplate);

export const query = graphql`
  query (
    $id: Int!
    $slug: String!
    $wpLocale: String!
    $wpGlobalConfig: String!
  ) {
    glossaryItem: wpGlossaryItem(
      databaseId: { eq: $id }
      language: { locale: { eq: $wpLocale } }
      acfGlobalConfiguration: { gcLinkTo: { in: [".all", $wpGlobalConfig] } }
    ) {
      seo {
        metaDesc
        title
      }

      title
      content
      excerpt
      date(formatString: "MMMM DD, YYYY")

      acfGlossaryRelatedTerms {
        glossaryRelatedTerms {
          term1 {
            title
            url
          }
          term2 {
            title
            url
          }
          term3 {
            title
            url
          }
        }
      }
    }

    relatedArticles: allWpPost(
      filter: {
        categories: {
          nodes: {
            elemMatch: { wpParent: { node: { slug: { regex: "/articles/" } } } }
          }
        }
        language: { locale: { eq: $wpLocale } }
        acfGlobalConfiguration: { gcLinkTo: { in: [".all", $wpGlobalConfig] } }
        slug: { regex: $slug }
      }
      sort: { order: DESC, fields: date }
      limit: 3
    ) {
      nodes {
        title
        slug
        excerpt
        date(formatString: "MMMM DD, YYYY")
        featuredImage {
          node {
            localFile {
              childImageSharp {
                gatsbyImageData(width: 690, layout: CONSTRAINED)
              }
            }
          }
        }
      }
    }

    latestArticles: allWpPost(
      filter: {
        categories: {
          nodes: {
            elemMatch: { wpParent: { node: { slug: { regex: "/articles/" } } } }
          }
        }
        language: { locale: { eq: $wpLocale } }
        acfGlobalConfiguration: { gcLinkTo: { in: [".all", $wpGlobalConfig] } }
      }
      sort: { order: DESC, fields: date }
      limit: 3
    ) {
      nodes {
        title
        slug
        excerpt
        date(formatString: "MMMM DD, YYYY")
        featuredImage {
          node {
            localFile {
              childImageSharp {
                gatsbyImageData(width: 690, layout: CONSTRAINED)
              }
            }
          }
        }
      }
    }
  }
`;
